import { registerShapeFactory } from '../base';
var SchemaShapeFactory = registerShapeFactory('schema', {
  defaultShapeType: ''
});
export default SchemaShapeFactory;